module.exports = __webpack_public_path__ + "static/media/MTL_SL_ALCOHOL2.e86fed58.png";